import React from 'react';
import { connectMenu } from 'react-instantsearch-core';
import { useCategory } from 'hooks';

const VirtualMenu = connectMenu(() => null);

function CategoryLocker() {
    const category = useCategory();
    if (category.id && category.level) {
        return (
            <VirtualMenu
                attribute={`categories.${category.level}.id`}
                defaultRefinement={`${category.id}`}
            />
        );
    }
    return null;
}

export default CategoryLocker;
